import { render, staticRenderFns } from "./textarea.vue?vue&type=template&id=8efc5cb8&scoped=true&"
import script from "./textarea.ts?vue&type=script&lang=ts&"
export * from "./textarea.ts?vue&type=script&lang=ts&"
import style0 from "./textarea.scss?vue&type=style&index=0&id=8efc5cb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8efc5cb8",
  null
  
)

export default component.exports